<template>
  <div>
    <v-select
      class="small-text-field"
      :required="required"
      :value="driverGroup"
      :label="label"
      :items="driverGroupsFiltered"
      :v-model="driverGroup"
      item-value="id"
      item-name="name"
      @input="updateSelf"
      :height="28"
      flat
      :hide-details="valid() == true && (error == null || error.length == 0)"
      :error-messages="valid() == true ? null : [valid()] "
      outlined
      dense
      style="width: 240px;"
    >
      <template v-slot:selection="{ item, index }">
      <span
        style="font-size: 12px !important"
        v-html="item.name"
      ></span>
      </template>
      <template v-slot:item="{ item, index }">
      <span
        style="font-size: 12px !important"
        v-html="'<b>' + item.name + '</b> &nbsp;'"
      ></span>
      </template>
    </v-select>
  </div>
</template>

<script>

import axios from "axios";
axios.defaults.withCredentials = true;


export default {
  name: "SelectableDriverGroupInput",
  components: {},
  model: {
    prop: "driverGroup",
    event: "input"
  },
  props: {
    label: String,
    errorMessages: Object,
    required: { type: Boolean, default: true },
    driverGroup: Number,
    error: String,
  },
  computed: {
    driverGroupsFiltered: function() {
      return this.driverGroups;
    }
  },
  data() {
    return {
      driverGroups: null
    };
  },
  mounted: function() {
      setTimeout(this.getDriverGroups, 300);
  },
  methods: {
    valid() {
      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(id) {
      this.$emit("input",id);
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    },
    getDriverGroups: async function() {
      try {
        var url = `${this.$store.state.apiUrl}/driver_group/all`;

        let response = await axios.get(url, {
          params: {}
        });

        this.driverGroups = response.data;
      } catch (e) {
        console.log(e);
      }
      
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
